import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonfiretvComponent } from './simple-icons-amazonfiretv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonfiretvComponent ],
    exports:      [ SimpleIconsAmazonfiretvComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonfiretvModule {}
